import React, {
  useEffect,
  useRef,
  useState
} from "react";
import MarketingDocGate from "../MarketingDocGate";

import { pageRules } from "../data";

import { lengthError } from "../../utils/validation";
import {
  Drawer,
  FormField,
  PageHeader,
  Select,
  Toggle
} from "../components/Shared";


function PageRules({ initial = {}, onSave }) {

  const initialRows = useRef(initial.rows || pageRules);
  const [rows, setRows] =
    useState(initialRows.current);

  // Persist whenever the list changes after load (create, edit and the active toggle all go through setRows).
  useEffect(() => {
    if (rows === initialRows.current) return;
    onSave({ rows }).catch((error) => window.alert(error.message || "Unable to save your changes."));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  const [open, setOpen] =
    useState(false);

  const [edit, setEdit] =
    useState(null);

  const [errors, setErrors] = useState({});


  const create = () => {

    setEdit({
      name: "",
      condition:
        "URL contains /pricing",
      behavior: "Show greeting",
      priority: 1,
      status: true
    });

    setErrors({});
    setOpen(true);
  };


  const save = () => {

    const found = {
      name: lengthError(edit.name, { min: 2, max: 80, label: "Rule name" }),
    };
    setErrors(found);
    if (Object.values(found).some(Boolean)) return;

    setRows((items) => {

      if (edit.id) {

        return items.map((item) =>
          item.id === edit.id
            ? edit
            : item
        );

      }

      return [
        {
          ...edit,
          id: Date.now()
        },
        ...items
      ];

    });

    setOpen(false);
  };


  return (
    <>

      <PageHeader
        eyebrow="MARKETING / TARGETING"
        title="Page rules"
        description="Control where and when marketing experiences are displayed."
        action="Create page rule"
        onAction={create}
      />


      <div className="rule-list">

        {rows.map((row) => (

          <div
            className="rule-card"
            key={row.id}
          >

            <div className="rule-number">
              {row.priority}
            </div>


            <div className="flex-grow-1">

              <div className="cell-title">
                {row.name}
              </div>

              <div className="rule-condition">

                <i className="bi bi-link-45deg"></i>

                {row.condition}

              </div>

            </div>


            <span className="behavior-tag">
              {row.behavior}
            </span>


            <Toggle
              label={`Rule ${row.name} is active`}
              checked={row.status}
              onChange={(value) =>
                setRows((items) =>
                  items.map((item) =>
                    item.id === row.id
                      ? {
                          ...item,
                          status: value
                        }
                      : item
                  )
                )
              }
            />


            <button
              className="row-menu"
              onClick={() => {

                setEdit(row);
                setErrors({});
                setOpen(true);

              }}
            >

              <i className="bi bi-pencil"></i>

            </button>

          </div>

        ))}

      </div>


      {open && (

        <Drawer
          title={
            edit.id
              ? "Edit page rule"
              : "Create page rule"
          }
          subtitle="Define the URL and behavior conditions."
          onClose={() =>
            setOpen(false)
          }
          footer={

            <>

              <button
                className="btn btn-light"
                onClick={() =>
                  setOpen(false)
                }
              >
                Cancel
              </button>

              <button
                className="btn btn-dark"
                onClick={save}
              >
                Save rule
              </button>

            </>

          }
        >

          <FormField label="Rule name" error={errors.name}>

            <input
              className="form-control"
              value={edit.name}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  name: e.target.value
                })
              }
              placeholder="Pricing pages"
            />

          </FormField>


          <FormField label="Page condition">

            <Select
              value={edit.condition}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  condition:
                    e.target.value
                })
              }
            >

              <option>
                URL contains /pricing
              </option>

              <option>
                URL starts with /docs
              </option>

              <option>
                URL equals /checkout
              </option>

              <option>
                URL matches pattern
              </option>

            </Select>

          </FormField>


          <FormField label="Behavior">

            <Select
              value={edit.behavior}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  behavior:
                    e.target.value
                })
              }
            >

              <option>
                Show greeting
              </option>

              <option>
                Show CTA
              </option>

              <option>
                Hide widget
              </option>

            </Select>

          </FormField>


          <FormField label="Priority">

            <input
              type="number"
              className="form-control"
              value={edit.priority}
              onChange={(e) =>
                setEdit({
                  ...edit,
                  priority:
                    Number(
                      e.target.value
                    )
                })
              }
            />

          </FormField>


          <div className="setting-row">

            <div>

              <strong>
                Enable rule
              </strong>

              <small>
                Apply this rule to matching pages.
              </small>

            </div>


            <Toggle
              label="Rule is active"
              checked={edit.status}
              onChange={(value) =>
                setEdit({
                  ...edit,
                  status: value
                })
              }
            />

          </div>

        </Drawer>

      )}

    </>
  );
}

export default function PageRulesPage() {
  return <MarketingDocGate section="rules">{({ doc, save }) => <PageRules initial={doc} onSave={save} />}</MarketingDocGate>;
}
